import { useEffect, useRef, useState } from 'react'
import { useHistory } from 'react-router-dom'
import FormWizard from 'react-form-wizard-component'
import 'react-form-wizard-component/dist/style.css'
import '../../../../Styles/FormWizard1.scss'
import Box from '../../../Global/Box'
import ContentHeader from '../../../Layout/ContentHeader'
import { toastSweetAlert } from '../../../Helpers/ToastSweetAlert'
import StepCitizen from './components/StepCitizen'
import StepReport from './components/StepReport'
//import StepFinal from './components/StepFinal'
import moment from 'moment'
import { useMutation } from '@apollo/client'
import {
  CREATE_REPORT_FROM_WEB,
  GET_ALL_REPORTS,
} from '../../../../graphql/Catalog/Reports/reports'
import { GET_USERS } from '../../../../graphql/Catalog/Users/user'
import { useLoading } from '../../../../LoadingOverlay/LoadingOverlayContext'
import FormUsersRatings from '../UsersRatings/Components/FormUsersRatings'

const backPage = '/report-capture'

const ReportWeb = () => {
  const refWizard = useRef()
  const history = useHistory()
  const { showLoading, hideLoading } = useLoading()
  const [isFinish, setIsFinish] = useState(false)

  const [isValidSteps, setIsValidSteps] = useState({
    step1: false,
    step2: false,
    //step3: true,
  })
  const [dataStep1, setDataStep1] = useState(null)
  const [dataStep2, setDataStep2] = useState(null)
  const [sendStartDate, setSendStartDate] = useState(null)
  const [userFound, setUserFound] = useState(false)

  const [formToQualify, setFormToQualify] = useState()

  const [createReportFromWeb] = useMutation(CREATE_REPORT_FROM_WEB, {
    refetchQueries: [
      {
        query: GET_USERS,
        variables: {
          limit: 10,
          offset: 0,
          searchQuery: null,
        },
      },
      {
        query: GET_ALL_REPORTS,
        variables: {
          limit: 10,
          offset: 0,
          searchQuery: null,
          filtersReports: {
            status_id: null,
            jurisdiction_id: null,
            sub_jurisdiction_id: null,
            nameColumnDateType: null,
            dateFrom: null,
            dateTo: null,
          },
        },
      },
    ],
  })

  //Esta funcion sirve para poder moverse entre steps, se ha comentado porque no se usara
  /* const handleClickStep = (stepNumber) => {
    let validSteps = {}

    setIsValidSteps((old) => {
      validSteps = old
      return { ...old }
    })

    if (stepNumber === 1) {
      return refWizard.current?.goToTab(1)
    } else if (stepNumber === 2) {
      if (!validSteps.step1) {
        return toastSweetAlert({
          mode: 'error',
          message: 'El paso 1 no se ha validado',
        })
      }
      return refWizard.current?.goToTab(2)
    } else if (stepNumber === 3) {
      if (!validSteps.step1 || !validSteps.step2) {
        return toastSweetAlert({
          mode: 'error',
          message: 'El paso 1 o 2 no se han validado',
        })
      }
      return refWizard.current?.goToTab(3)
    }
  } */

  const tabChanged = ({ prevIndex, nextIndex }) => {}

  useEffect(() => {})

  //Guardar reporte
  const handleComplete = async () => {
    let input = {}
    //Hacer algunas validaciones
    try {
      if (!dataStep1 || !dataStep2) throw new Error('No hay datos capturados')
      if (!dataStep1) throw new Error('No hay datos capturados')
      if (!dataStep2) throw new Error('No hay datos capturados')

      if (dataStep1) {
        const {
          id_user_app,
          name,
          phone,
          address: addressCitizen,
          isGestor,
          isAnonymous,
        } = dataStep1

        if (!userFound && (!phone || !addressCitizen))
          throw new Error('Faltan datos del ciudadano')

        if (!addressCitizen) throw new Error('Faltan datos del ciudadano')

        if (!isGestor && !isAnonymous)
          input.user_citizen = {
            ...(id_user_app && { user_id: id_user_app }),
            name: name,
            phone,
            address: addressCitizen,
          }
        else {
          if (isGestor)
            input.user_gestor = {
              user_id: id_user_app,
            }
          else if (isAnonymous)
            input.user_anonymous = {
              user_id: id_user_app,
            }
        }
      }

      if (dataStep2) {
        const {
          priority,
          group_id,
          group_category_id,
          group_category_sub_id,
          file,
          fileImg,
          address,
          data_form_json,
        } = dataStep2

        //YA NO ES NECESARIO, SE OMITE DESDE DONDE SE MANDA
        // if (filteredObject.evidences) {
        //   delete filteredObject.evidences
        // }

        input.group_id = group_id
        input.group_category_sub_id = group_category_sub_id
        input.group_category_id = group_category_id
        input.send_start_date = sendStartDate
        input.data_form_json = JSON.stringify(data_form_json)
        input.file = file
        input.fileImg = fileImg
        // input.evidences = evidences
        input.priority = priority

        if (!address?.zone_id) throw new Error('Faltan datos de la zona')
        input.zone_id = address?.zone_id

        /* if (!address?.colony_number || !address?.colony_name) throw new Error('Faltan datos de la colonia') */
        input.colony = {
          name: address?.colony_name,
          number: address?.colony_number,
        }
        input.address = {
          street: address?.address_components?.street ?? 'N/A',
          zipcode: address?.address_components?.postalCode ?? 0,
          state: address.address_components?.state,
          city: address.address_components?.city,
          reference: address?.address_reference ?? '',
          latitude: `${address.markerPosition.lat}`,
          longitude: `${address.markerPosition.lng}`,
          address_full: address.full_address,
          url_google_map: address.url,
        }
      }
    } catch (error) {
      return toastSweetAlert({
        mode: 'error',
        message: error.message,
      })
    }

    showLoading()
    try {
      const resFolio = await createReportFromWeb({
        variables: {
          input,
        },
      })
      return (
        toastSweetAlert({
          mode: 'ok',
          message: resFolio?.data?.reportCreationFromWeb
            ? `Reporte con el folio #${resFolio.data.reportCreationFromWeb} creado con éxito`
            : 'Reporte creado con éxito',
        }),
        history.push(backPage)
      )
    } catch (error) {
      setIsFinish(false)
      return toastSweetAlert({
        mode: 'error',
        message: error.message,
      })
    } finally {
      hideLoading()
    }
  }

  ///ESTE Efecto es para agregar un metodo onCLick a cada LI de steps - Se comento por que no se usara
  //Agregar onClick a cada LI de steps
  /* useEffect(() => {
    const stepItems = document.querySelectorAll('.form-wizard-steps li')
    if (stepItems.length > 1) {
      stepItems[0].onclick = () => handleClickStep(1)
      stepItems[1].onclick = () => handleClickStep(2)
      stepItems[2].onclick = () => handleClickStep(3)
    }
  }, []) */

  useEffect(() => {
    if (isFinish === true) {
      handleComplete()
    }
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isFinish])

  useEffect(() => {
    setSendStartDate(moment().format('YYYY-MM-DD HH:mm:ss'))
  }, [])

  return (
    <>
      <ContentHeader
        title=""
        titleContent={
          <div className="col-12 col-sm-6">
            <h1 className="header-title">Captura de reporte</h1>
          </div>
        }
        breadcrumb=""
        windowTitle={`Vista detalle del reporte`}
      />

      <Box
        withCard
        clasCard="card report-web"
        contentHeader={
          <>
            <h3 className="card-title pl-3 mt-0">Formulario</h3>
          </>
        }
        classNameHeader="card-header p-0"
        content={
          <FormWizard
            ref={refWizard}
            shape="circle"
            color="#F97316"
            title={false}
            onComplete={handleComplete}
            onTabChange={tabChanged}
            backButtonTemplate={() => null}
            nextButtonTemplate={() => null}
            finishButtonTemplate={() => null}
            finishButtonText={() => null}
            /* finishButtonText={
              <>
                Terminar <i className="fas fa-save ml-1" />
              </>
            } */
          >
            <FormWizard.TabContent
              title="DATOS DEL CIUDADANO"
              icon="fa fa-user"
            >
              <StepCitizen
                refWizard={refWizard}
                setIsValidSteps={setIsValidSteps}
                data={dataStep1}
                setData={setDataStep1}
                setUserFound={setUserFound}
                userFound={userFound}
                setFormToQualify={setFormToQualify}
                formToQualify={formToQualify}
              />
            </FormWizard.TabContent>
            {formToQualify && (
              <FormWizard.TabContent
                title="CALIFICAR A SERVIDOR PÚBLICO"
                icon="fas fa-star"
              >
                <FormUsersRatings backPage={backPage} />
              </FormWizard.TabContent>
            )}

            {!formToQualify && (
              <FormWizard.TabContent
                title="DATOS DEL REPORTE"
                icon="fas fa-envelope-open-text"
                isValid={isValidSteps.step1}
              >
                <StepReport
                  refWizard={refWizard}
                  setIsValidSteps={setIsValidSteps}
                  data={dataStep2}
                  setData={setDataStep2}
                  setIsFinish={setIsFinish}
                />
              </FormWizard.TabContent>
            )}
            {/* <FormWizard.TabContent
              title="Enviar"
              icon="fas fa-mail-bulk"
              isValid={isValidSteps.step1 && isValidSteps.step2}
            >
              <StepFinal
                refWizard={refWizard}
                setIsValidSteps={setIsValidSteps}
                handleComplete={handleComplete}
              />
            </FormWizard.TabContent> */}
          </FormWizard>
        }
      />
    </>
  )
}

export default ReportWeb
